import { render, staticRenderFns } from "./IntroTask.vue?vue&type=template&id=45ee59f2&scoped=true&"
import script from "./IntroTask.vue?vue&type=script&lang=js&"
export * from "./IntroTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ee59f2",
  null
  
)

export default component.exports